<!-- <div class="text-right mb-1">
    <button pButton pRipple icon="pi pi-comment" class="text-xl font-semibold btn-action" size="large"
        style="font-size: 10px !important;" [label]="'message.new_message' | translate"
        (click)="openDialogSendMessage(null, null);">
    </button>
</div> -->

<p-dataView #dv [value]="listMessages" [style]="{ width: '100%' }">
    <ng-template pTemplate="list" let-message>        
        <div class="grid grid-nogutter">            
            <div class="card col-12" *ngFor="let item of message; let first = first" style="border-radius: 16px !important; border: 1px solid #d1c6c6; cursor: pointer;"
                (click)="openChatMessageDialog(item)">
                <div class="flex flex-column sm:flex-row sm:align-items-center p-4 gap-3">
                    <div class="md:w-5rem relative">
                        <div class="image-container responsive-image" [ngStyle]="{backgroundImage: 'url(assets/layout/images/perfil.svg)'}" *ngIf="!item.IsOrder && !item.PictureUri"></div>
                        <img *ngIf="!item.IsOrder && item.PictureUri" class="responsive-image"
                            [src]="item.PictureUri"
                            [alt]="item.name" style="border-radius: 32px !important;" />
                        <img *ngIf="item.IsOrder" class="responsive-image"
                            [src]="'https://tse1.mm.bing.net/th/id/OIP.DWKo0zDibHJHeSjJv2a9rgHaE7?rs=1&pid=ImgDetMain&o=7&rm=3'"
                            [alt]="item.name" style="border-radius: 32px !important;" />                        
                    </div>
                    <div
                        class="flex flex-column md:flex-row justify-content-between md:align-items-center flex-1 gap-4">
                        <div class="flex flex-row md:flex-column justify-content-between align-items-start gap-2">
                            <div>
                                <span class="text-lg font-medium text-900">{{ item.IsOrder ? ('Pedido #' + item.Key) : item.Key }}</span>
                                <div [innerHtml]="item.Label" class="font-medium text-secondary text-sm mt-2"></div>
                            </div>
                        </div>
                        <div class="flex flex-column md:align-items-end gap-5">
                            <!-- <span class="text-xl font-semibold text-900">{{item.Elements?.length}}</span> -->
                             <p *ngIf="item?.length > 0" style="border-radius: 10px;" class="bg-indigo-500 font-bold px-2 py-1 text-indigo-100 text-lg">{{item?.length}}</p>
                            <div class="flex flex-row-reverse md:flex-row gap-2">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</p-dataView>

<p-dialog *ngIf="chatMessageDialog" [(visible)]="chatMessageDialog" [style]="{width: '80vw', height: '80hw', 'max-height': '80hw'}"
    [modal]="true" styleClass="p-fluid" header="Mensagens" #dialog>

    <ng-container *ngFor="let chat of chatList; let i = index">
        <ul>
            <div *ngIf="chat.sourceUserId != userId">
                <li class="message-from">
                    <div class="message-meta">
                        <p-avatar [label]="getInitials(chat.sourceUserName)"
                            [style]="{ 'background-color': AVATAR_COLOR_FROM, 'color': 'white', 'font-weight': 'bold' }"></p-avatar>
                        <span class="name ml-2">{{chat.sourceUserName}}</span>
                        <span class="time ml-2">{{chat.dateOfRegistration | date: 'dd/MM/yyyy HH:mm'}}</span>
                        <span *ngIf="chat.woOrderId != null" class="name ml-2">Pedido #{{chat.code}}</span>
                        
                        <button *ngIf="chat.woOrderId != null && chat.sourceUserName != 'System Admin'" pButton pRipple icon="pi pi-comment" class="text-xl font-semibold btn-action mt-2"
                            size="large" style="font-size: 10px !important;" [label]="'message.new_message' | translate"
                            (click)="openDialogSendMessage(chat.woOrderId, chat.sourceUserId);">
                        </button>
                    </div>
                    <div class="message">
                        <span><label [innerHtml]="chat.message"></label></span>
                    </div>
                </li>
            </div>
            <div *ngIf="chat.sourceUserId == userId">
                <li class="message-own">
                    <div class="message">
                        <span><label [innerHtml]="chat.message"></label></span>
                    </div>
                    <div class="message-meta">
                        <p-avatar [label]="getInitials(chat.targetUserName)"
                            [style]="{ 'background-color': AVATAR_COLOR_OWN, 'color': 'white', 'font-weight': 'bold' }"></p-avatar>
                        <span class="name ml-2">{{chat.targetUserName}}</span>
                        <span class="time ml-2">{{chat.dateOfRegistration | date: 'dd/MM/yyyy HH:mm'}}</span>
                        <span *ngIf="chat.woOrderId != null" class="name ml-2">Pedido #{{chat.code}}</span>
                    </div>
                </li>
            </div>
        </ul>
    </ng-container>
    
    <ng-template pTemplate="footer">
        <div *ngIf="!isOrder">
            <div class="field col-12">
                <label for="message" class="font-medium hidden md:block text-2xl">
                    <span translate>message.send_message</span> {{ isClient ? woOrder?.clientName : woOrder?.userName }}
                </label>
            </div>
            <div class="write-message">
                <i class="pi pi-paperclip"></i>
                <input #inputMessage pInputText type="text" id="message" [(ngModel)]="message" [disabled]="false" autofocus/>
            </div>
            <button pButton pRipple [disabled]="!message" icon="pi pi-send" style="width: 150px;"
                class="text-xl font-semibold mt-1" [label]="'Enviar'" (click)="sendMessage();">
            </button>
        </div>
    </ng-template>

</p-dialog>

<p-dialog *ngIf="displaySendMessage" [(visible)]="displaySendMessage" [style]="{ height:'50hw', width: '50vw' }"
    [contentStyle]="{'overflow-y': 'none'}" [header]="dialogHeaderSendMessage" [modal]="true" styleClass="fluid">
    <app-sc-user-message-send [woOrder]="woOrder" [clientName]="woOrder?.clientName" [userName]="woOrder?.userName"
        (chosedItem)="refreshData()" [listUser]="listUser" [sourceUserId]="sourceUserId">
    </app-sc-user-message-send>
</p-dialog>